import { render, staticRenderFns } from "./export-format.vue?vue&type=template&id=3ed7c796&"
import script from "./export-format.vue?vue&type=script&lang=js&"
export * from "./export-format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports